import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { AccessToken, checkedFetchAccessTokenIfNeeded, State } from '~/AccessToken';

import NavigationMenu, { Access } from './NavigationMenu';

const selectAccess = memoizeOne((accessToken: AccessToken | null): Access | null => {
	if (accessToken === null || accessToken.subscription === null) {
		return null;
	}

	const { systemModules } = accessToken.subscription;
	return {
		irp: systemModules.has('erp'),
		analytics: systemModules.has('analytics'),
		search: systemModules.has('search-app'),
		productGroups: systemModules.has('product-groups'),
	};
});

function mapStateToProps({ accessToken }: { accessToken: State }): {
	access: Access | null;
} {
	return {
		access: selectAccess(accessToken.accessToken),
	};
}

const actions = {
	onFetch: checkedFetchAccessTokenIfNeeded,
};

export default connect(mapStateToProps, actions)(NavigationMenu);
